var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-inline-tile" }, [
    _vm.image || _vm.imageAlternative
      ? _c(
          "div",
          { staticClass: "global-inline-tile__image" },
          [
            _vm.image === "placeholder"
              ? _c("div", { staticClass: "global-inline-tile__placeholder" })
              : _vm.image
              ? _c(
                  _vm.imageLink ? "a" : "span",
                  { tag: "a", attrs: { href: _vm.imageLink } },
                  [
                    _c("img", {
                      attrs: { src: _vm.image, width: "68", alt: _vm.title },
                    }),
                  ]
                )
              : _vm.imageAlternative
              ? _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.imageAlternative) },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "global-inline-tile__content" },
      [
        _c(_vm.titleLink ? "a" : "span", {
          tag: "a",
          staticClass: "global-inline-tile__title",
          attrs: { href: _vm.titleLink },
          domProps: { innerHTML: _vm._s(_vm.title) },
        }),
        _vm._v(" "),
        _vm.subtitle
          ? _c("span", {
              staticClass: "global-inline-tile__subtitle",
              domProps: { innerHTML: _vm._s(_vm.subtitle) },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.text
          ? _c("span", { domProps: { innerHTML: _vm._s(_vm.text) } })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }